exports.components = {
  "component---src-pages-automotive-js": () => import("./../../../src/pages/automotive.js" /* webpackChunkName: "component---src-pages-automotive-js" */),
  "component---src-pages-classic-js": () => import("./../../../src/pages/classic.js" /* webpackChunkName: "component---src-pages-classic-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-scene-js": () => import("./../../../src/pages/scene.js" /* webpackChunkName: "component---src-pages-scene-js" */)
}

